import React from 'react'
import {
  Modal, Panel, ListGroup, ListGroupItem, ControlLabel,
  FormGroup, FormControl
} from 'react-bootstrap'
import { values, compact } from 'lodash'
import { browserHistory } from 'react-router'

import Button from '../components/Button.jsx'
import { getText } from '../lib/text.js'
import { getStatusLabel } from '../trips/TripStatus.js'
import { getLeaderName, getTripCode } from '../../lib/TripTools'

import removeDiacritics from '../../lib/diacritics.js'

type TripsSelectorModalProps = {
  close: () => void,
  trips: {[string]: Object},
  setClientPickerSearch: Function,
  search: string,
  list: []
}

const match = (term, prop) => (
  prop && removeDiacritics(prop).toLowerCase().replace(/\s/g, '').indexOf(term) >= 0
)

function filterByName(term, list) {
  if (!term || term.length <= 2) return []

  const cleanTerm = term.toLowerCase().replace(/\s/g, '')

  return list.filter(t => {
    return (
      match(cleanTerm, t.name)
      || match(cleanTerm, t.officialName)
      || match(cleanTerm, getLeaderName(t))
      || match(cleanTerm, t.realName)
      || match(cleanTerm, t.wechat)
      || match(cleanTerm, getTripCode(t))
    )
  })
}

const otherNames = trip => (
  compact([trip.name, trip.officialName, getLeaderName(trip)]).join(" / ")
)

const TripsSelectorModal = (props: TripsSelectorModalProps) => (
  <Modal show onHide={() => props.close()}>
    <Modal.Header>
      <Modal.Title>{getText("Buscar cliente")}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <FormGroup>
        <ControlLabel>{getText("Introducir nombre")}:</ControlLabel>
        <FormControl
          style={{marginLeft: 8}}
          value={props.search}
          onChange={evt => props.setClientPickerSearch(evt.target.value) }
          autoFocus
        />
      </FormGroup>
      <Panel style={{maxHeight: 400, marginTop: 15, overflowY: "scroll"}}>
        <Panel.Heading>{getText("Resultados de la búsqueda")}</Panel.Heading>
        <Panel.Body>
          <ListGroup>
            {
              props.list.map(trip => (
                <ListGroupItem
                  key={trip._id}
                  header={
                    <h3>
                      {trip.realName || trip.name}
                      <small style={{ marginLeft: 10 }}>
                        ({otherNames(trip)})
                        {` [${getTripCode(trip)}]`}
                      </small>
                    </h3>
                  }
                  onClick= {() => { browserHistory.push(`/private/trip/${encodeURIComponent(trip._id)}?`) }}
                >
                  {trip.wechat != "" && (<span style={{fontWeight: "bold"}}>WeChat: </span>)}{`${trip.wechat}`}
                  <span style={{fontWeight: "bold", marginLeft: "10px"}}>Estado: </span>{`${getStatusLabel(trip.status)}`}
                  <span style={{fontWeight: "bold", marginLeft: "10px"}}>Encargado: </span>{`${trip.encargado}`}
                </ListGroupItem>
              ))
            }
            {
              props.list.length == 0 && (
                <div style={{ fontStyle: "italic", textAlign: "center", margin: "auto", paddingTop: 6 }}>
                  {
                    (props.search.length == 0 && "Introduce tu búsqueda")
                    || (props.search.length <= 2 && "Al menos 3 caracteres")
                    || "Sin resultados"
                  }
                </div>
              )
            }
          </ListGroup>
        </Panel.Body>
      </Panel>
    </Modal.Body>
    <Modal.Footer>
      <Button
        bsStyle="success"
        onClick={() => props.close()}
      >
        {getText("Cerrar")}
      </Button>
    </Modal.Footer>
  </Modal>
)

/**
 *
 */
type TripsSelectorButtonProps = {
  trips: {[string]: Object},
  setClientPicker: Function,
  setClientPickerSearch: Function,
  query: Object,
}

const TripsSelectorButton = (props: TripsSelectorButtonProps) => (
  <div style={{display: "inline-block"}}>
    <Button
      glyph="search"
      onClick={() => props.setClientPicker(true) }
    >
      {getText("Buscador")}
    </Button>
    {
      (props.query.modal == "false" || !props.query.modal)
        ? ""
        : (
          <TripsSelectorModal
            trips= {props.trips}
            list={filterByName(props.query.clientSearch || "", values(props.trips))}
            search= {props.query.clientSearch || ""}
            setClientPickerSearch= {clientSearch => props.setClientPickerSearch(clientSearch)}
            query={props.query}
            close={() => { props.setClientPicker(false); props.setClientPickerSearch("") }}
          />
        )
    }
  </div>
)
export default TripsSelectorButton
